import { Component, OnInit } from '@angular/core';
import { TwitterService } from './twitter.service';

@Component({
  selector: 'social-twitter-img',
  template: `
    <img *ngIf="data.profile_image_url" [src]="data.profile_image_url" alt="twitter profile photo">
  `,
  styles: [`
    :host{
      img{
        border:1px solid #dbdbdb;
        border-radius: 50%;
        margin: 5px;
      }
    }
  `]
})
export class TwitterImgComponent implements OnInit {

  private data: any = {};

  constructor(private service: TwitterService) { }

  ngOnInit() {
    this.service.subject.subscribe(data => {
      this.data = data;
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/social/twitter/twitter-img.component.ts